import { motion } from 'framer-motion';
import { ScrambleText } from '@/components/ScrambleText';

const CODE_LINE_2 = 'if(medium.shift()){art.redefine();perception.question();reality.blur();}//digitalism.emerge()';

export default function CulturalShiftSection() {
  return (
    <section
      data-testid="cultural-shift-section"
      className="relative z-10 px-6 sm:px-10 py-20 lg:py-28"
    >
      <div className="overflow-hidden mb-16">
        <div
          className="code-divider-scroll whitespace-nowrap text-[10px] font-mono text-[#1a1a1a] select-none"
          style={{ animationDirection: 'reverse' }}
        >
          {CODE_LINE_2} {CODE_LINE_2} {CODE_LINE_2} {CODE_LINE_2}
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <ScrambleText
            text="WHY? THE CULTURAL SHIFT"
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight uppercase text-white font-outfit block"
            as="h2"
            duration={800}
            distortOnHover
          />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mt-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ScrambleText
              text="WE ARE ENTERING A NEW ERA"
              className="text-xl sm:text-2xl font-medium font-outfit text-white tracking-tight block mb-6"
              as="h3"
              duration={600}
              distortOnHover
            />
            <div className="space-y-5">
              <p className="text-sm sm:text-base leading-relaxed font-mono text-[#f6f6f6]">
                SHIFTS IN MEDIUM ARE RESHAPING HOW ART IS MADE AND UNDERSTOOD.
                AUDIENCES SEEK IMMERSIVE EXPERIENCES. PERCEPTION & REALITY ARE
                INCREASINGLY QUESTIONED.
              </p>
              <p className="text-sm sm:text-base leading-relaxed font-mono text-[#f6f6f6]">
                TENSIONS BETWEEN TRADITIONAL AND AI PRACTICES SIGNAL A BROADER
                SHIFT, THOUGH IN PRACTICE THESE APPROACHES OFTEN CONVERGE THROUGH
                SHARED CONCERNS AROUND SYSTEMS, IMAGE-MAKING, AND CONSTRUCTION.
              </p>
              <p className="text-sm sm:text-base leading-relaxed font-mono text-[#f6f6f6]">
                THE CURRENT MOMENT NEEDS TO BE UNDERSTOOD AS THE EARLY STAGES OF A
                NEW MOVEMENT, REFERRED TO AS &lsquo;DIGITALISM&rsquo;. OUR AMBITION IS TO
                ESTABLISH THE GALLERY AS A LEADING DESTINATION FOR DIGITAL ART IN
                CENTRAL EASTERN EUROPE.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.35 }}
          >
            <div className="relative overflow-hidden border border-[#222222] h-full group/img">
              <img
                src="/images/cultural-shift.jpeg"
                alt="The cultural shift"
                className="w-full h-full object-cover opacity-50 grayscale group-hover/img:opacity-100 group-hover/img:grayscale-0 transition-all duration-700"
                data-testid="cultural-shift-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent group-hover/img:from-transparent transition-all duration-700" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
